/**
 * Xodim ismi -> profil sahifasi (/people/:id). Recruiter faqat o'zini ochadi, boshqalar uchun oddiy matn.
 * Qolgan rollarda havola bo'ladi; doiradan tashqaridagi profilni backend baribir bermaydi (404).
 */
import { Fragment, type MouseEvent, type ReactNode } from "react";
import { Link } from "react-router";
import { useMe } from "@/features/auth/hooks";
import type { Me, Role } from "@/features/auth/types";
import { cn } from "@/lib/utils";

export function canOpenPerson(me: Pick<Me, "id" | "role"> | null | undefined, personId: number | null | undefined, personRole?: Role | string | null): boolean {
  if (!me || !personId) return false;
  if (me.id === personId) return true;
  if (me.role === "recruiter" || me.role === "carrier") return false;
  // Owner profilini faqat owner ochadi
  if (personRole === "owner" && me.role !== "owner") return false;
  return true;
}

export function personPath(id: number): string {
  return `/people/${id}`;
}

export function PersonLink({ id, name, role, className }: { id: number | null | undefined; name: ReactNode; role?: Role | string | null; className?: string }) {
  const me = useMe().data;
  if (!id || !canOpenPerson(me, id, role)) return <span className={className}>{name}</span>;
  return (
    <Link
      to={personPath(id)}
      // Qator yoki karta bosilishi (driver profiliga o'tish) ishlamasin
      onClick={(e: MouseEvent) => e.stopPropagation()}
      className={cn("hover:text-primary hover:underline", className)}
    >
      {name}
    </Link>
  );
}

/** Bir nechta xodim (filial menejerlari, jamoa lead'lari): vergul bilan havolalar; hech kim bo'lmasa -- "—" */
export function PersonLinks({ people, role }: { people: { id: number; display_name: string }[]; role?: Role | string | null }) {
  if (people.length === 0) return <span className="text-muted">—</span>;
  return (
    <>
      {people.map((p, i) => (
        <Fragment key={p.id}>
          {i > 0 && ", "}
          <PersonLink id={p.id} name={p.display_name} role={role} />
        </Fragment>
      ))}
    </>
  );
}
